"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useIpfsService } from "@/components/ipfs/IPFSContext";
import { QueryKey, ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserSettingsImgSelectFile from "@/components/user/settings/UserSettingsImgSelectFile";
import UserSettingsImgSelectMeme, { MemeLite } from "@/components/user/settings/UserSettingsImgSelectMeme";
import UserSettingsSave from "@/components/user/settings/UserSettingsSave";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import { ApiCreateOrUpdateProfileRequest } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { commonApiFetch, commonApiPost, commonApiPostForm } from "@/services/api/common-api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { FormEvent, useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function UserPageHeaderEditPfp(t0) {
  const $ = _c(63);
  const {
    profile,
    onClose
  } = t0;
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const ipfsService = useIpfsService();
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onProfileEdit
  } = useContext(ReactQueryWrapperContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: [QueryKey.MEMES_LITE],
      queryFn: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: memes
  } = useQuery(t1);
  let t2;
  if ($[1] !== profile.pfp) {
    t2 = profile.pfp ? getScaledImageUri(profile.pfp, ImageScale.W_200_H_200) : null;
    $[1] = profile.pfp;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [imageToShow, setImageToShow] = useState(t2);
  const [selectedMeme, setSelectedMeme] = useState(null);
  const [file, setFile] = useState();
  const [error, setError] = useState(null);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = meme => {
      setSelectedMeme(meme);
      setFile(null);
      setError(null);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setSelectedMemeAndRemoveFile = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = file_0 => {
      setFile(file_0);
      setSelectedMeme(null);
      setError(null);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const setFileAndRemoveMeme = t4;
  let t5;
  let t6;
  if ($[5] !== file || $[6] !== selectedMeme) {
    t5 = () => {
      if (file) {
        setImageToShow(URL.createObjectURL(file));
      } else {
        if (selectedMeme) {
          setImageToShow(selectedMeme.scaled ?? selectedMeme.image);
        }
      }
    };
    t6 = [file, selectedMeme];
    $[5] = file;
    $[6] = selectedMeme;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  const [saving, setSaving] = useState(false);
  let t7;
  if ($[9] !== ipfsService || $[10] !== profile.banner1 || $[11] !== profile.banner2 || $[12] !== profile.classification || $[13] !== profile.handle || $[14] !== profile.query) {
    t7 = async body => {
      setSaving(true);
      const pfp = body.get("pfp");
      if (!profile.handle) {
        throw new Error("Profile handle is required");
      }
      if (pfp) {
        if (!profile.classification) {
          return;
        }
        const cid = await ipfsService.addFile(pfp as File);
        const ipfs = `ipfs://${cid}`;
        const ipfsBody = {
          handle: profile.handle,
          classification: profile.classification,
          pfp_url: ipfs
        };
        if (profile?.banner1) {
          ipfsBody.banner_1 = profile?.banner1;
        }
        if (profile?.banner2) {
          ipfsBody.banner_2 = profile?.banner2;
        }
        const response = await commonApiPost({
          endpoint: "profiles",
          body: ipfsBody
        });
        return response?.pfp;
      } else {
        const response_0 = await commonApiPostForm({
          endpoint: `profiles/${profile.query}/pfp`,
          body
        });
        return response_0.pfp_url;
      }
    };
    $[9] = ipfsService;
    $[10] = profile.banner1;
    $[11] = profile.banner2;
    $[12] = profile.classification;
    $[13] = profile.handle;
    $[14] = profile.query;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onClose || $[17] !== onProfileEdit || $[18] !== profile || $[19] !== setToast) {
    t8 = pfp_url => {
      onProfileEdit({
        profile: {
          ...profile,
          pfp: pfp_url ?? null
        },
        previousProfile: null
      });
      setFile(null);
      setSelectedMeme(null);
      setToast({
        message: "Profile updated",
        type: "success"
      });
      onClose();
    };
    $[16] = onClose;
    $[17] = onProfileEdit;
    $[18] = profile;
    $[19] = setToast;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== setToast) {
    t9 = error_0 => {
      setToast({
        message: error_0 as string,
        type: "error"
      });
    };
    $[21] = setToast;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setSaving(false);
    };
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t11 = {
      mutationFn: t7,
      onSuccess: t8,
      onError: t9,
      onSettled: t10
    };
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const updatePfp = useMutation(t11);
  let t12;
  if ($[28] !== file || $[29] !== requestAuth || $[30] !== selectedMeme || $[31] !== setToast || $[32] !== updatePfp) {
    t12 = async e => {
      e.preventDefault();
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in to save settings",
          type: "error"
        });
        return;
      }
      if (!file && !selectedMeme) {
        setError(null);
        setToast({
          message: "You must select an image",
          type: "error"
        });
        return;
      }
      if (file && file.size > 2097152) {
        setError("File size must be less than 2MB");
        return;
      }
      const formData = new FormData();
      if (file) {
        formData.append("pfp", file);
      }
      if (selectedMeme) {
        formData.append("meme", selectedMeme.id.toString());
      }
      await updatePfp.mutateAsync(formData);
    };
    $[28] = file;
    $[29] = requestAuth;
    $[30] = selectedMeme;
    $[31] = setToast;
    $[32] = updatePfp;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const onSubmit = t12;
  if (typeof document === "undefined") {
    return null;
  }
  let t13;
  if ($[34] !== onClose) {
    t13 = <button type="button" aria-label="Close edit profile picture modal" className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-cursor-pointer tw-border-none tw-p-0" onClick={onClose} />;
    $[34] = onClose;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== memes) {
    t14 = memes ?? [];
    $[36] = memes;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14) {
    t15 = <UserSettingsImgSelectMeme memes={t14} onMeme={setSelectedMemeAndRemoveFile} />;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="tw-inline-flex tw-items-center tw-my-2 tw-justify-center tw-w-full"><hr className="tw-w-full tw-h-px tw-border tw-bg-iron-800" /><span className="tw-absolute tw-px-3 tw-font-semibold tw-text-sm tw-uppercase tw-text-iron-300">or</span></div>;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== imageToShow) {
    t17 = <UserSettingsImgSelectFile imageToShow={imageToShow} setFile={setFileAndRemoveMeme} />;
    $[41] = imageToShow;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== error) {
    t18 = error && <p className="tw-mt-3 tw-text-sm tw-text-red">{error}</p>;
    $[43] = error;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const t19 = !file && !selectedMeme;
  let t20;
  if ($[45] !== saving || $[46] !== t19) {
    t20 = <UserSettingsSave loading={saving} disabled={t19} title="Save PFP" />;
    $[45] = saving;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== onClose || $[49] !== saving) {
    t21 = <SecondaryButton disabled={saving} onClicked={onClose} className="tw-w-full sm:tw-w-auto tw-mt-3 sm:tw-mt-0">Cancel</SecondaryButton>;
    $[48] = onClose;
    $[49] = saving;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t20 || $[52] !== t21) {
    t22 = <div className="tw-pt-6"><div className="sm:tw-flex sm:tw-flex-row-reverse tw-gap-x-3">{t20}{t21}</div></div>;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== onSubmit || $[55] !== t15 || $[56] !== t17 || $[57] !== t18 || $[58] !== t22) {
    t23 = <div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-center tw-justify-center tw-p-2 lg:tw-p-4"><div ref={modalRef} className="sm:tw-max-w-3xl md:tw-max-w-2xl tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6 lg:tw-p-8"><form onSubmit={onSubmit}>{t15}{t16}{t17}{t18}{t22}</form></div></div>;
    $[54] = onSubmit;
    $[55] = t15;
    $[56] = t17;
    $[57] = t18;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== t13 || $[61] !== t23) {
    t24 = createPortal(<div className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1100] tw-cursor-default">{t13}{t23}</div>, document.body);
    $[60] = t13;
    $[61] = t23;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  return t24;
}
async function _temp() {
  const memesResponse = await commonApiFetch({
    endpoint: "memes_lite"
  });
  return memesResponse.data;
}